import { loadAllExternalScripts } from './utils/load-once.js';
import { init } from './core/init.js';

console.log(
  '%cTHIS SITE USES BOLKLAB',
  'background:#000;color:#fff;font-weight:700;font-size:13px;padding:6px 12px;border-radius:3px;letter-spacing:0.05em;'
);
console.log(
  "Hey there 👀 — BolkLab is a JS library built and owned by Bolk Studio. We make Webflow sites that actually perform. Check us out → https://www.bolk.studio/"
);

function start() {
  loadAllExternalScripts(window.BolkExternalScripts || {});
  init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
